exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/bizisystem-frontend/src/src/app/main/frames/domains/domains.component.css
// module id = ../../../../../src/app/main/frames/domains/domains.component.css
// module chunks = main